import React from "react";
import { tv } from "tailwind-variants";

interface ToggleButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  type?: "primary" | "secondary";
}

const toggleButtonVariants = tv({
  base: "flex justify-center items-center h-[36px] px-[18px] py-0 gap-[8px] cursor-pointer rounded-[222px] border-[2px] text-[14px] font-normal leading-[17.64px] tracking-[1.5px] uppercase focus:ring-[3px] focus:ring-offset-2 focus:ring-ominimo-400 focus:outline-none",
  variants: {
    type: {
      primary:
        "border-ghost-110 bg-ghost-110 hover:bg-white hover:border-gray-200 hover:text-black text-black",
      secondary: "bg-white border-gray-200 text-gray-550 hover:border-gray-376",
    },
    isActive: {
      true: "",
    },
  },
  compoundVariants: [
    {
      type: "primary",
      isActive: true,
      className: "border-black bg-white text-black hover:border-black",
    },
    {
      type: "secondary",
      isActive: true,
      className: "bg-gray-550 text-white border-gray-550 hover:border-gray-550",
    },
  ],
  defaultVariants: {
    type: "primary",
  },
});

export const ToggleButton = ({ label, isActive, onClick, type }: ToggleButtonProps) => {
  return (
    <button onClick={onClick} className={toggleButtonVariants({ type, isActive })}>
      {label}
    </button>
  );
};
